import api from './api';
import { Beratungstermin, CreateBeratungsterminRequest, Berater, CreateBeraterRequest } from '../types';

export const beratungService = {
  // Öffentlich – ohne Login vom iPad-Formular aufrufbar
  async create(request: CreateBeratungsterminRequest): Promise<Beratungstermin> {
    const response = await api.post<Beratungstermin>('/beratungstermine', request);
    return response.data;
  },

  async getAll(): Promise<Beratungstermin[]> {
    const response = await api.get<Beratungstermin[]>('/beratungstermine');
    return response.data;
  },

  async setErledigt(id: number, erledigt: boolean): Promise<Beratungstermin> {
    const response = await api.patch<Beratungstermin>(`/beratungstermine/${id}/erledigt`, { erledigt });
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/beratungstermine/${id}`);
  },
};

export const beraterService = {
  // Öffentlich lesbar (für die Auswahl im iPad-Formular)
  async getAll(): Promise<Berater[]> {
    const response = await api.get<Berater[]>('/berater');
    return response.data;
  },

  // Verwaltung – nur Admin
  async create(request: CreateBeraterRequest): Promise<Berater> {
    const response = await api.post<Berater>('/berater', request);
    return response.data;
  },

  async update(id: number, request: CreateBeraterRequest): Promise<Berater> {
    const response = await api.put<Berater>(`/berater/${id}`, request);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/berater/${id}`);
  },
};
